module.exports = __webpack_public_path__ + "img/img_about_2.eeace0fd.png";